import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Attributions() {

    // Click and scroll
    // function handleClick(elementId) {
    //     const scrollElement = document.getElementById(elementId)
    //     scrollElement.scrollIntoView({behavior: "smooth"});
    //     // setTimeout(function () {
    //     //     scrollElement.scrollIntoView({behavior: "smooth"});
    //     // }, 100);
    //     console.log(elementId)
    // }

    return (
        <div className="flex flex-col">

            {/* Header */}
            <Navbar/>

            <div className="mt-5 sm:px-24 px-4">
                <iframe
                    className="h-screen w-full"
                    title="attributionForm"
                    id="igem-attribution-form"
                    src="https://teams.igem.org/wiki/5122/attributions"
                >
                </iframe>
            </div>

            {/* Sidebar turns into subheader in mobile device */}
            {/*<div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">*/}
            {/*    <div className="flex items-center py-4">*/}
            {/*        <button type="button" className="text-gray-500 hover:text-gray-600"*/}
            {/*                data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"*/}
            {/*                aria-label="Toggle navigation">*/}
            {/*            <span className="sr-only">Toggle Navigation</span>*/}
            {/*            <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">*/}
            {/*                <path fillRule="evenodd"*/}
            {/*                      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>*/}
            {/*            </svg>*/}
            {/*        </button>*/}
            {/*        <ol className="ms-3 flex items-center whitespace-nowrap">*/}
            {/*            <li className="flex items-center text-sm text-gray-800">*/}
            {/*                Team*/}
            {/*                <svg*/}
            {/*                    className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"*/}
            {/*                    width="16" height="16" viewBox="0 0 16 16" fill="none"*/}
            {/*                    xmlns="http://www.w3.org/2000/svg">*/}
            {/*                    <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"*/}
            {/*                          stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>*/}
            {/*                </svg>*/}
            {/*            </li>*/}
            {/*            <li className="text-sm font-semibold text-gray-800 truncate">*/}
            {/*                Attributions*/}
            {/*            </li>*/}
            {/*        </ol>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*/!* Main Content *!/*/}
            {/*<div className="lg:flex grow max-w-[85rem] w-full mx-auto">*/}

            {/*    /!* Sidebar with accordion *!/*/}
            {/*    <div id="description-sidebar"*/}
            {/*         className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">*/}
            {/*        <div className="px-6">*/}
            {/*            <div className="flex-none text-xl font-semibold px-1">*/}
            {/*                Attributions*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <nav className="p-6 w-full flex flex-col flex-wrap">*/}
            {/*            <ul className="space-y-1.5">*/}
            {/*                <li>*/}
            {/*                    <div onClick={() => handleClick("Attribution-3")}*/}
            {/*                         className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"*/}
            {/*                         href="#">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>*/}
            {/*                        Team member contributions*/}
            {/*                    </div>*/}
            {/*                </li>*/}
            {/*                <li>*/}
            {/*                    <div onClick={() => handleClick("Attribution-4")}*/}
            {/*                         className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"*/}
            {/*                         href="#">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>*/}
            {/*                        External contributions*/}
            {/*                    </div>*/}
            {/*                </li>*/}
            {/*                <li>*/}
            {/*                    <div onClick={() => handleClick("Attribution-5")}*/}
            {/*                         className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"*/}
            {/*                         href="#">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>*/}
            {/*                        Project timeline*/}
            {/*                    </div>*/}
            {/*                </li>*/}

            {/*            </ul>*/}
            {/*        </nav>*/}
            {/*    </div>*/}

            {/*    /!* Major text sections *!/*/}
            {/*    <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">*/}
            {/*        <div>*/}
            {/*            <div id="Attribution-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">*/}
            {/*                Team member contributions*/}
            {/*            </div>*/}
            {/*            <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">*/}
            {/*                Our efforts together brought to life our BioGlimmer project. Below we have shortly*/}
            {/*                described the efforts made by each team member, as well as the contributions offered by*/}
            {/*                outside expertises.*/}
            {/*            </div>*/}
            {/*            <div className="text-lg text-gray-800">*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Felix Falk*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student Leader*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Notebook/record keeping,*/}
            {/*                            Project Administration, Fundraising, Public Engagement, Writing, Safety*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration - team member recruitment; planning, coordination and*/}
            {/*                                management of the team and its activities.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - presenting the project at the Swedish and Nordic iGEM*/}
            {/*                                conferences, participating in the ethics of cosmetics workshop.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - project description, Swedish translations, iGEM Stockholm For*/}
            {/*                                Dummies handbook.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Safety - ensuring project compliance with iGEM and KTH Royal Institute of*/}
            {/*                                Technology regulations.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Dimitrios Tsagkogiannis*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Fundraising, Public Engagement,*/}
            {/*                            Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development. Researching in order to curate*/}
            {/*                                the entrepreneurial strategy, including market access and financial*/}
            {/*                                planning strategies of the team. Participating in iGEM Startups Summer*/}
            {/*                                School and implementing the feedback on the project.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Fundraising - Raising money and foundings for the project and team*/}
            {/*                                activities, through grant applications and conducting stakeholders.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - Participating in the Swedish and presenting at the*/}
            {/*                                Nordic iGEM conference and the European Meetup hosted by iGEM Madrid.*/}
            {/*                                Promoting iGEM to finance students for recruitment. Conducted*/}
            {/*                                stakeholders and pitched to startup incubation hubs.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - Making presentations and posters, providing suggestions*/}
            {/*                                for the media team with logo, merch. Creating content for the board game*/}
            {/*                                in collaboration with other Swedish iGEM teams.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - Writing finance and entrepreneurship wiki.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data curation - Keeping record of the team’s budget. Ensuring that the*/}
            {/*                                team's financial planning strategy is based on data.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Aleksandras Gaudiesius*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Fundraising*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Fundraising - raising money and foundings for the project and team activities.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Jiaxin Wu*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Investigation, Data Curation, Project Administration, Public Engagement, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization: Brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research: Finding and reading papers on different projects.*/}
            {/*                                Participating in dry lab workshops and investigating methods used in*/}
            {/*                                plasmid design and metabolic engineering.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation: Checking restriction enzyme cutting site and primer design.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data Curation: Performing metabolic engineering(maximum theoretical yield*/}
            {/*                                and flux analysis).*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration: Subteam meetings in wet and dry lab.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement: Presenting the project and poster in Bielefeld*/}
            {/*                                Conference. Promoting igem to finance students for recruitment.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing: Writing wiki page of dry lab, including plasmid design and*/}
            {/*                                modeling.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Mai Nguyen*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Investigation, Data Curation,*/}
            {/*                            Notebook/record keeping, Project Administration, Public Engagement,*/}
            {/*                            Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - researching scientific articles during*/}
            {/*                                brainstorming and project development, pitching the guanine crystal idea.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation - identifying and troubleshooting experimental design from*/}
            {/*                                dry lab aspect.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data curation: collecting, organizing and tailoring plasmid designs,*/}
            {/*                                documents and presentations.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Notebook/record keeping - recording feedbacks and changes for plasmid*/}
            {/*                                designs with relevant references.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration - being dry lab team leader, organizing group work*/}
            {/*                                and getting updates.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - participating in the Swedish iGEM conferences and*/}
            {/*                                presenting the project to master’s students for iGEM promotion.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - creating insertion and plasmids visualization, making*/}
            {/*                                presentations, providing suggestions for media team with logo, slogan*/}
            {/*                                and merch.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - writing dry lab wiki.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Carmen de Ancos Jimeno*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Background Research, Wetlab, Investigation, Data Curation, Notebook/record*/}
            {/*                            keeping, Public Engagement, Writing, Visualization*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development, literature research on guanine*/}
            {/*                                crystals in bacteria and for laboratory procedures.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Wetlab - Planning and conducting wet lab experiments, Carrying out*/}
            {/*                                molecular cloning and vector preparations protocols, transforming E. coli*/}
            {/*                                with expression vectors, gel electrophoresis,SDS page gels, preparation*/}
            {/*                                of samples for sequencing,guanine assay.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation - Contributing to error handling/investigation of wet lab*/}
            {/*                                experiments/problems.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data Curation- gathering results from wet lab experiments, analyzing and*/}
            {/*                                reporting them.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Notebook/record keeping - gathering data from wet lab experiments and*/}
            {/*                                keeping track of literature research documents and physical/digital*/}
            {/*                                laboratory protocols.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - presenting the project at the Danish DTU BioBrick*/}
            {/*                                conference, participating in the DTU BioBrick workshops, lectures, and*/}
            {/*                                labs, and attending the Nordic iGEM conference, carrying out presentations*/}
            {/*                                about our project and iGEM for master students promoting them to join the*/}
            {/*                                next year’s team.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - results,  laboratory protocols, data documentation,*/}
            {/*                                proof of concept.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - Suggesting ideas and creating prototypes/sketches for*/}
            {/*                                the media team: team logo, team slogan)*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Maria Gustavsson*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Wetlab, Investigation, Data Curation,*/}
            {/*                            Notebook/record keeping, Project Administration, Public Engagement, Writing,*/}
            {/*                            Visualization*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development, literature research on guanine*/}
            {/*                                crystals in bacteria and for laboratory procedures.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Wetlab - Planning and conducting wet lab experiments, Carrying out*/}
            {/*                                molecular cloning and vector preparations protocols, transforming E. coli*/}
            {/*                                with expression vectors, gel electrophoresis, preparation of samples for*/}
            {/*                                sequencing,guanine assay.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation - Contributing to error handling/investigation of wet lab*/}
            {/*                                experiments/problems.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data Curation- gathering results from wet lab experiments, analyzing and*/}
            {/*                                reporting them.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Notebook/record keeping - gathering data from wet lab experiments and*/}
            {/*                                keeping track of literature research documents and physical/digital*/}
            {/*                                laboratory protocols.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration - subteam meetings wet and dry lab, communicating*/}
            {/*                                and contributing to team and subteam meetings.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - presenting the project at the Danish DTU BioBrick*/}
            {/*                                conference, participating in the DTU BioBrick workshops, lectures, and*/}
            {/*                                labs, and attending the Nordic iGEM conference.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - wiki project description, laboratory protocols, data documentation.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - Suggesting ideas and creating prototypes/sketches for the*/}
            {/*                                media team: team mascot, team logo, team stickers.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Meghana Bhat*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Investigation, Data*/}
            {/*                            Curation, Notebook/record keeping, Public engagement, Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization: Actively participated in the brainstorming phase of the*/}
            {/*                                project, researched and pitched various ideas and helped other*/}
            {/*                                brainstorming groups in their process.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background research: Read relevant literature for the final project idea.*/}
            {/*                                Compiled and constructed protocols for the experiments.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation (wet-lab): Planned and participated in wet-lab procedures*/}
            {/*                                such as plasmid construction, transformation and analysis of expression*/}
            {/*                                (guanine assay).*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data Curation: Compiled and saved relevant data and results, analyzed*/}
            {/*                                results and contributed to troubleshooting whenever necessary.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Notebook/record keeping: Kept track of laboratory work and experiments in*/}
            {/*                                a physical lab-notebook and on shared online platforms such as benchling*/}
            {/*                                and google drive.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement: Participated in the DTU BioBrick workshop and the*/}
            {/*                                Nordic iGEM conference (NiC). Presented the project idea and the team,*/}
            {/*                                participated in laboratory exercises, lectures and workshops at the DTU*/}
            {/*                                BioBrick workshop. Participated in lectures, presented the project*/}
            {/*                                (during poster sessions) and the visual aid (powerpoint) for the team*/}
            {/*                                presentation at NiC.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization: Contributed to the brainstorming process for the project*/}
            {/*                                logo, team logo, stickers and the project description video. Also helped*/}
            {/*                                in making and uploading posts/stories for the team instagram.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing: Wiki-writing; Engineering, protocols, notebook & Experiments.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Other: In charge of ordering laboratory supplies, reagents and equipment*/}
            {/*                                for the wet-lab team.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Juliana Baranova*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Analysis, Conceptualization, Background Research, Investigation,*/}
            {/*                            Data Curation, Notebook/record keeping, Writing, Safety, Public Engagement*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Analysis: analyzed data from literature, generated by other iGEM teams*/}
            {/*                                and our team during the project execution.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Conceptualization: participated in brainstorming and project design.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research: performed literature review and research related to*/}
            {/*                                project needs, experimental design and used methods.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Investigation: participated in wetlab activities such as molecular*/}
            {/*                                cloning, plasmid purification, PCR, guanine assay and overall reagents*/}
            {/*                                and sample handling.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Data Curation: annotating (producing metadata), cleaning, and maintaining*/}
            {/*                                research data for your team's project and for future use by other iGEM teams.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Notebook/record keeping: maintaining the laboratory notebook in benchling*/}
            {/*                                and physically, keeping a record of wetlab activities.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing: writing SOPs, editing texts for Wiki pages and presentations*/}
            {/*                                (e.g. at NiC).*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Safety: checking up reagents SDS sheets, manuals and protocols for*/}
            {/*                                safety considerations, following local lab safety protocols for biological*/}
            {/*                                and chemical material handling and equipment usage.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement: presenting the project at the Nordic iGEM Conference*/}
            {/*                                (NiC 2024), sharing iGEM Stockholm project achievements on personal social*/}
            {/*                                media.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Diandra Daumiller*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student Human Practices subleader*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Project Administration, Public*/}
            {/*                            Engagement, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - finding and reading scientific articles during*/}
            {/*                                brainstorming and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration - human practices and media, communicating and*/}
            {/*                                contributing to team and subteam meetings.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - presenting the project at the Nordic iGEM Conferences*/}
            {/*                                and university career fairs; participating in the ethics of cosmetics*/}
            {/*                                workshop at St. Martins Gymnasium (make-up high school). Reaching out to*/}
            {/*                                stakeholders, professors, cosmetic companies and schools to discuss our*/}
            {/*                                project impact and receive useful feedback. Collaboration with other iGEM*/}
            {/*                                teams. Creation of iGEM Celebration game to celebrate the 10th project of*/}
            {/*                                iGEM Stockholm and get people to know about a synthetic biology research*/}
            {/*                                development process in an interactive way.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - project description, project presentation preparation, involved*/}
            {/*                                in wiki writing.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Hongge Wang*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Public Engagement, Wiki Coding, Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - Brainstormed for project ideas*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - Provided illustrations for activities*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Wiki Coding - Coded the wiki with React and Tailwind CSS*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - Created logos and wiki illustrations*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - Wrote for wiki contents*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Edna Lam*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Project Administration, Public Engagement, Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - Brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Project Administration - Organized subgroup (Media) team meetings and*/}
            {/*                                contributed to weekly team meetings.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - Responsible for posting on all the team’s social*/}
            {/*                                media accounts, Presented the project at the Swedish iGEM conference.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - Creation and animation of promotion and presentation*/}
            {/*                                video, Designed team mascot and other elements for team merchandise.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing -  Involved in wiki writing.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Teodora Pavlicu*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Student*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Conceptualization, Background Research, Public Engagement, Visualization, Writing*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - brainstorming of ideas and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Background Research - reading scientific articles during brainstorming*/}
            {/*                                and project development.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Public Engagement - presenting the project at Bielefield conference,*/}
            {/*                                participating in the ethics of cosmetics workshop.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Visualization - participation in preparation, creation and filming of*/}
            {/*                                promotion and presentation video, poster, presentations, part of video*/}
            {/*                                script and instagram posts.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Writing - project description, Swedish translation.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Siri Flemming Svedmark*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Instructor*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Project administration, Analysis, Conceptualization*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Project administration - ordering of reagents.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - Discussed the project design and experimental*/}
            {/*                                workflow, demonstrated lab equipment.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Analysis - helped troubleshoot experimental errors.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Emma Larsson*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Instructor*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Project Administration, Analysis, Conceptualization*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Project administration - ordering of reagents.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Conceptualization - Discussed the project design and experimental*/}
            {/*                                workflow, demonstrated lab equipment.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Analysis - helped troubleshoot experimental errors.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="mt-5">*/}
            {/*                    <div className="text-2xl font-bold">*/}
            {/*                        <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                        Johan Rockberg*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-4">*/}
            {/*                        <div className="font-bold">*/}
            {/*                            Role:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            PI*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Task:*/}
            {/*                        </div>*/}
            {/*                        <div className="pl-8">*/}
            {/*                            Project Administration, Conceptualization*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <div className="font-bold mt-2">*/}
            {/*                            Specific Task:*/}
            {/*                        </div>*/}
            {/*                        <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                            <li>*/}
            {/*                                Project administration - Administrative work, ordering of reagents.*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                Fundraising - co-applicant for the Vinnova grant.*/}
            {/*                            </li>*/}
            {/*                        </ol>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="text-lg text-gray-800">*/}
            {/*            <div id="Attribution-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">*/}
            {/*                External contributions*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Laura Nilsson*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization, Background Research*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - participating in project brainstorming.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Background Research - researching project ideas.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Cathy Sun*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Public Engagement, Visualization, Writing*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Public Engagement - Contacting stakeholders, iGEM Madrid conference participant.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Visualization - creating presentation materials.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Writing - stakeholder outreach, human practices texts.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Vinnova*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Government + Sponsor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Fundraising*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Fundraising - awarded the team the grant “Everyday innovators in biotech and synthetic biology”.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    KTH Royal Institute of Technology*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + Sponsor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Fundraising*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Fundraising - awarded the team a project grant.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Karolinska Institutet*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + Sponsor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Fundraising*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Fundraising - awarded the team two project grants.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Axel Knave*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - gave a workshop on SnapGene, Benchling and plasmid design,*/}
            {/*                            reviewed and gave feedback on plasmid designs.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Gunaratna Kuttuva Rajarao*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Safety*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Safety - Organized a safety introduction to the lab, including waste disposal,*/}
            {/*                            fire safety, working with gene modified microorganisms and provided us with*/}
            {/*                            the necessary regulatory documents.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Stockholm Genetically Engineered Machine*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Nonprofit + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Project Administration, Conceptualization, Public Engagement, Fundraising*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Project Administration - interviewed team member applicants, recruited the*/}
            {/*                            team leader, organized workshops for the team.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion, provided*/}
            {/*                            guidance throughout the project.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Public engagement - marketed iGEM to university students with posters,*/}
            {/*                            presentations and mingling sessions.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Fundraising - provided bank account and advised fundraising strategy,*/}
            {/*                            co-applicant for the Vinnova grant.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Arthur Nassai Herren*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Visualization, Project Management*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Visualization - team photo photographer.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Project management - interviewing candidates.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Integrated DNA Technologies*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Industry + Sponsor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Fundraising*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Fundraising - provided the team with DNA oligos free of charge.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Microsynth*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Industry + Sponsor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Investigation*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Investigation - provided the team with sequencing services free of charge.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Anna Beronius*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Ute Römling*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Niclas Roxhed*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Onur Parlak*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Wouter van der Wijngaart*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Matti Sällberg*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Dan Sheward*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Academic + External Advisor*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - panelist in the brainstorming panel discussion.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    iGEM Uppsala University*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Nonprofit + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization, Public Engagement, Visualization, Writing*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Public Engagement - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Visualization - visuals for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Writing - text for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    iGEM Chalmers-Gothenburg*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Nonprofit + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization, Public Engagement, Visualization, Writing*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Public Engagement - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Visualization - visuals for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Writing - text for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    iGEM Linköping*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Nonprofit + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization, Public Engagement, Visualization, Writing*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Public Engagement - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Visualization - visuals for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Writing - text for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    iGEM Lund*/}
            {/*                </div>*/}
            {/*                <div className="mt-4">*/}
            {/*                    <div className="font-bold">*/}
            {/*                        Role:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Nonprofit + Collaborator*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        General Task:*/}
            {/*                    </div>*/}
            {/*                    <div className="pl-8">*/}
            {/*                        Conceptualization, Public Engagement, Visualization, Writing*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div>*/}
            {/*                    <div className="font-bold mt-2">*/}
            {/*                        Specific Task:*/}
            {/*                    </div>*/}
            {/*                    <ol className="list-decimal space-y-2 pl-12 mt-2">*/}
            {/*                        <li>*/}
            {/*                            Conceptualization - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Public Engagement - creating the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Visualization - visuals for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                        <li>*/}
            {/*                            Writing - text for the Swedish iGEM card game.*/}
            {/*                        </li>*/}
            {/*                    </ol>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="text-lg text-gray-800">*/}
            {/*            <div id="Attribution-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">*/}
            {/*                Project timeline*/}
            {/*            </div>*/}
            {/*            <div className="mt-8">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Project Activity: Recruit Team Members*/}
            {/*                </div>*/}
            {/*                <div className="pl-8">*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Start Date: 2023-09-01*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        End Date: 2024-01-07*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Total Time (weeks): 17*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Project Activity: Development of Project Plan*/}
            {/*                </div>*/}
            {/*                <div className="pl-8">*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Start Date: 2024-04-29*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        End Date: 2024-05-26*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Total Time (weeks): 4*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Project Activity: Wet Laboratory Activities*/}
            {/*                </div>*/}
            {/*                <div className="pl-8">*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Start Date: 2024-06-03*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        End Date: 2024-09-22*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Total Time (weeks): 16*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Project Activity: Dry Laboratory Activities*/}
            {/*                </div>*/}
            {/*                <div className="pl-8">*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Start Date: 2024-05-06*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        End Date: 2024-08-11*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Total Time (weeks): 14*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="mt-5">*/}
            {/*                <div className="text-2xl font-bold">*/}
            {/*                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block mr-4"></span>*/}
            {/*                    Project Activity: Building the Team Wiki*/}
            {/*                </div>*/}
            {/*                <div className="pl-8">*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Start Date: 2024-06-03*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        End Date: 2024-10-02*/}
            {/*                    </div>*/}
            {/*                    <div className="mt-2">*/}
            {/*                        Total Time (weeks): 18*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="h-16"></div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Footer */}
            <Footer />
        </div>
    )
}